// Permission action map — defines available actions per section
export const SECTION_ACTIONS = {
  products:   { label:'Product Research', icon:'◈', actions:[
    { id:'view', label:'View' }, { id:'edit', label:'Edit' },
    { id:'create', label:'Create' }, { id:'delete', label:'Delete' },
    { id:'generate', label:'Generate' },
  ]},
  funnel:     { label:'Funnel Building', icon:'⬡', actions:[
    { id:'view', label:'View' }, { id:'edit', label:'Edit' },
    { id:'create', label:'Create' }, { id:'delete', label:'Delete' },
    { id:'audit', label:'Audit' }, { id:'wetracked', label:'Wetracked' },
    { id:'checklist', label:'Checklist' },
  ]},
  creatives:  { label:'Creatives', icon:'◐', actions:[
    { id:'view', label:'View' }, { id:'edit', label:'Edit' },
    { id:'create', label:'Create' }, { id:'delete', label:'Delete' },
  ]},
  adcopy:     { label:'Ad Copy', icon:'◻', actions:[
    { id:'view', label:'View' }, { id:'edit', label:'Edit' },
    { id:'create', label:'Create' }, { id:'delete', label:'Delete' },
    { id:'adapt', label:'Adapt' },
  ]},
  scheduling: { label:'Ad Scheduling', icon:'◷', actions:[
    { id:'view', label:'View' }, { id:'edit', label:'Edit' },
    { id:'create', label:'Create' }, { id:'delete', label:'Delete' },
  ]},
  winning:    { label:'Winning Products', icon:'◆', actions:[
    { id:'view', label:'View' }, { id:'edit', label:'Edit' },
    { id:'create', label:'Create' }, { id:'delete', label:'Delete' },
  ]},
  reports:    { label:'Reports', icon:'📊', actions:[
    { id:'view', label:'View' },
  ]},
}

// Check if user can perform an action in a section
// permissions structure: { funnel: { view:true, edit:true, ... } }
// Backward compat: { funnel: true } means all actions enabled
export function can(permissions, section, action) {
  if (!permissions) return false
  const p = permissions[section]
  if (p === true) return true              // old format = full access
  if (typeof p === 'object' && p) return !!p[action]
  return false
}

// Does user have ANY access to a section (for sidebar visibility)?
export function hasSection(permissions, section) {
  if (!permissions) return false
  const p = permissions[section]
  if (p === true) return true
  if (typeof p === 'object' && p) return Object.values(p).some(Boolean)
  return false
}
